export default __webpack_public_path__ + "static/media/kitchen5-afterD-1920w.173eedf0.webp";